<template>
  <header v-if="nameRouter !== 'Landing' && nameRouter !== 'DetailMobile'">
    <div
      v-if="load"
      style="
        position: fixed;
        inset: 0;
        background: #00000040;
        z-index: 999;
        display: flex;
        align-items: center;
        justify-content: center;
      "
    >
      <img src="https://devpe.joinnus.com/inc/img/Isotipo-black.gif" alt="Joinnus" style="width: 60px" />
    </div>
    <nav style="height: 64px" class="navbar navbar-dark navbar-expand-sm py-0" :class="btnColorTheme">
      <div :class="containerTheme">
        <router-link :to="nameSlug" class="navbar-brand py-2">
          <div>
            <img
              :src="imageLogoTheme"
              :width="isFPF ? 200 : 130"
              class="align-top d-none d-md-block"
              alt="Logo"
              @click="refresh()"
            />
            <img
              :src="imageLogoTheme"
              :width="isFPF ? 160 : 130"
              class="d-inline-block align-top d-md-none"
              alt="Logo"
              @click="refresh()"
            />
          </div>
        </router-link>
        <div v-if="disableSale" class="form-inline">
          <div class="nav-item d-flex align-items-center">
            <div class="p-2 d-none d-lg-block">
              <router-link class="d-print-block nav-link-active text-dark" :to="{ name: 'Verify' }"
                >Mis entradas</router-link
              >
            </div>
          </div>
          <div class="nav-item d-flex align-items-center">
            <div class="p-2 d-none d-md-block">
              <a href="/#price" class="btn btn-action px-3"> Comprar entradas </a>
            </div>
          </div>
          <div class="d-none d-md-block d-lg-none nav-item d-flex align-items-center p-2">
            <router-link :to="{ name: 'Verify' }">
              <img
                src="https://cdn.joinnus.com/files/fpf_ticket.svg"
                width="35"
                height="35"
                alt
              />
            </router-link>
          </div>
        </div>
        <div class="form-inline ml-auto pr-3">
          <div class="nav-item d-flex align-items-center position-relative">
            <div class="p-2 d-none d-md-block">
              <a v-if="validateTheme" href="/verificar-ganador" class="btn btn-primary px-4 rounded-pill">
                <strong>Verifica si ganaste</strong>
              </a>
              <a
                v-if="pathRouter !== '/login' && !sessionUser"
                :href="'/login?redirect=' + pathRouter"
                class="btn btn-dark px-4 rounded-pill ml-3 position-relative"
              >
                <strong>Iniciar sesión</strong>
              </a>
              <!-- <div class="cup position-absolute" v-if="isFPF" style="top: 0; left: -80px; z-index: 1">
                <img
                  src="https://cdn.joinnus.com/prime/fpf_2024/peru_paraguay/WC2026.svg"
                  alt=""
                />
              </div> -->
            </div>
          </div>
        </div>
        <div v-if="sessionUser" class="d-flex align-items-center">
          <div v-if="false" class="mr-4 d-none d-lg-block">
            <img src="https://cdn.joinnus.com/files/2022/fpf/paraguay/VRS.png" alt="" />
          </div>
          <div class="text-capitalize font-weight-bold d-none d-md-block">
            {{ sessionUser.name }}
          </div>
          <!-- <div class="cup position-absolute d-md-none" v-if="isFPF" style="top: 0; right: 24%; z-index: 1">
            <img
              src="https://cdn.joinnus.com/prime/fpf_2024/peru_paraguay/WC2026.svg"
              alt=""
            />
          </div> -->
          <div class="dropdown-user">
            <div class="dropdown-user__link">
              <div class="dropdown-user__image">
                <img
                  class="rounded-circle border"
                  :src="sessionUser.avatar || 'https://www.joinnus.com/static/images/avatar.svg'"
                  alt="User"
                  width="35"
                  height="35"
                />
              </div>
              &nbsp;
              <i class="fa fa-angle-down text-dark" />
            </div>
            <div class="dropdown-user__links">
              <div class="dropdown-user__options">
                <a :href="`${baseUrlAccount}`" target="_blank" rel="noopener noreferrer">
                  <i class="fa fa-user" />
                  <span>Perfil</span>
                </a>
                <a :href="`${baseUrlAccount}tickets`" target="_blank" rel="noopener noreferrer">
                  <i class="fa fa-ticket" />
                  <span>Ver mis entradas</span>
                </a>
                <a v-if="validateTheme" href="/verificar-ganador" rel="noopener noreferrer">
                  <i class="fa fa-pencil" />
                  <span>Verifica si ganaste</span>
                </a>
                <a @click="logout" style="cursor: pointer">
                  <i class="fa fa-power-off" />
                  <span>Cerrar sesión</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="form-inline w-100 d-md-none" v-if="!isFPF">
        <div class="nav-item d-flex align-items-center">
          <div class="">
            <a v-if="validateTheme" href="/verificar-ganador" class="btn btn-primary px-3 rounded-pill my-1 btn-sm p-2">
              <small><strong>Verifica si ganaste</strong></small>
            </a>
            <a
              v-if="pathRouter !== '/login' && !sessionUser"
              href="/login?redirect=/"
              class="btn btn-dark px-3 my-1 rounded-pill ml-2 btn-sm"
            >
              <small><strong>Iniciar sesión</strong></small>
            </a>
          </div>
        </div>
      </div>
    </nav>
  </header>
</template>
<script>
import { AUTH_COOKIES } from '../../consts';
import api from '../../api';

const { VUE_APP_ENV } = process.env;

export default {
  data() {
    return {
      liveUrlEncode: '',
      baseUrlAccount:
        VUE_APP_ENV === 'development' ? 'https://devmyaccount.joinnus.com/' : 'https://myaccount.joinnus.com/',
      baseUrl: '',
      load: false,
    };
  },
  metaInfo() {
    return {
      meta: [
        { name: 'keywords', content: this.keywords },
        { name: 'description', content: this.description },
        { vmid: 'twitter:title', name: 'twitter:title', content: this.title },
        { vmid: 'twitter:card', name: 'twitter:card', content: 'summary' },
        { vmid: 'twitter:site', name: 'twitter:site', content: '@joinnus' },
        { vmid: 'twitter:image', name: 'twitter:image', content: this.imageUrl },
        { vmid: 'twitter:description', name: 'twitter:description', content: this.description },
        { vmid: 'og:title', property: 'og:title', content: this.title },
        { vmid: 'fb:app_id', property: 'fb:app_id', content: '533016930075522' },
        { vmid: 'og:type', property: 'og:type', content: 'website' },
        { vmid: 'og:url', property: 'og:url', content: this.url },
        { vmid: 'og:image', property: 'og:image', content: this.imageUrl },
        { vmid: 'og:description', property: 'og:description', content: this.description },
      ],
    };
  },
  computed: {
    url() {
      return window.location.origin + this.$route.path;
    },
    title() {
      if (this.slugRouter === 'barriolatino') {
        return 'Barrio Latino Remix 2023';
      }
      if (this.isFPF) {
        return 'Perú Amistosos FIFA | La Bicolor juega en casa, Compra tus entradas en Joinnus | El Fútbol nos une';
      }
      if (this.slugRouter === 'alianzalimavscerroporteno') {
        return 'Alianza lima vs Cerro porteño';
      }
      return 'Joinnus';
    },
    subtitle() {
      if (this.slugRouter === 'barriolatino') {
        return 'Bizarrap';
      }
      if (this.isFPF) {
        return 'La Bicolor juega en casa, Compra tus entradas en Joinnus | El Fútbol nos une';
      }
      if (this.slugRouter === 'alianzalimavscerroporteno') {
        return 'Copa libertadores 2024';
      }
      return 'Venta de entradas';
    },
    description() {
      if (this.slugRouter === 'barriolatino') {
        return 'Barrio Latino Remix 2023, Bizarrap, Maria Becerra, Cazzu, Cris MJ, DJ Playero y más.';
      }
      if (this.isFPF) {
        return 'Peru vs Venezuela por las clasificatorias al mundial 2026. Compra tus entradas en Joinnus.com y apoya a nuestra selección | Joinnus - El fútbol nos une';
      }
      return 'Eventos en tu ciudad';
    },
    imageUrl() {
      if (this.slugRouter === 'barriolatino') {
        return 'https://cdn.joinnus.com/user/1374864/638e3bf081d44.jpg';
      }
      return 'https://cdn.joinnus.com/user/2/act62193c45dbd38.jpg';
    },
    nameSlug() {
      const { name, params, path } = this.$route;
      const { slug } = params;
      if (name === 'DetailReservate' || name === 'DetailReservate' || this.isFPF) {
        return { route: path };
      }
      if (slug === 'fpf') {
        return { name: 'Menu' };
      }
      if (slug === 'karolg') {
        return { name: 'Karolg' };
      }
      if (slug === 'arjona') {
        return { name: 'Arjona' };
      }
      if (slug === 'test') {
        return { name: 'Test' };
      }
      return { name: 'Home' };
    },
    keywords() {
      if (this.isFPF) {
        return 'Joinnus, La Bicolor, Selección peruana de Fútbol, Compra de entradas, venta de entradas, clasificatorias mundial 2026, fútbol peruano';
      }
      return this.title;
    },
    eventData() {
      return this.$store.state.eventData;
    },
    slugRouter() {
      return this.$route.params.slug;
    },
    pathRouter() {
      return this.$route.path;
    },
    nameRouter() {
      return this.$route.name;
    },
    sessionUser() {
      return this.$store.state.auth.user;
    },
    sessionToken() {
      return this.$store.state.auth.token;
    },
    validateTheme() {
      if (
        (this.hostname === 'deventradas.joinnus.com' ||
          this.hostname === 'preprodfpf.joinnus' ||
          this.hostname === 'fpf.joinnus.com') &&
        this.pathname === '/fpf'
      ) {
        return false;
      }
      return false;
    },
    imageLogoTheme() {
      if (this.hostname === 'preprodfpf.joinnus' || this.hostname === 'fpf.joinnus.com' || this.nameRouter === 'Fpf') {
        return 'https://cdn.joinnus.com/fpf_2023/fpf-br/Desktop/SVG/logotipos-nav.svg';
      }
      if (this.hostname === 'adidas.joinnus.com') {
        return 'https://cdn.joinnus.com/files/2022/adidas/logo-lima42k-new.png';
      }
      return 'https://cdn.joinnus.com/files_cache/logo-joinnus.svg';
    },
    btnColorTheme() {
      if (this.hostname === 'preprodfpf.joinnus' || this.hostname === 'fpf.joinnus.com' || this.nameRouter === 'Fpf') {
        return 'bg-dark py-2 fixedNav text-white';
      }
      if (this.hostname === 'adidas.joinnus.com') {
        return 'navbar-lima42k pb-3 pt-2  border-bottom';
      }
      return 'border-bottom';
    },
    containerTheme() {
      if (this.hostname === 'preprodfpf.joinnus' || this.hostname === 'fpf.joinnus.com' || this.nameRouter === 'Fpf') {
        return 'container';
      }
      return 'container-fluid';
    },
    isFPF() {
      return this.$route.name === 'Fpf';
    },
    hostname() {
      return window.location.hostname;
    },
    pathname() {
      return window.location.pathname;
    },
  },
  methods: {
    refresh() {
      if (!this.isFPF) return;
      window.location.reload();
    },
    async logout() {
      const { token } = this.$store.state.auth;
      try {
        this.load = true;
        const { status } = await api.logout(token);
        if (status) {
          if (document) {
            document.cookie = `verifySession=;expires=0`;
            document.cookie = `${AUTH_COOKIES}=;expires=0`;
          }
          if (localStorage) {
            localStorage.clear();
          }
          this.$router.go();
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.load = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.fixedNav {
  position: fixed;
  z-index: 12;
  width: 100%;
}

@media (max-width: 768px) {
  .cup {
    display: none !important;
  }
}
</style>
